import { apiFetch } from './client';
import { collectPages } from './project-pages';
import type { Paginated, Project } from '$lib/types';

export type ProjectInput = { name: string; client_name: string; location: string };

export const projectsApi = {
  list: (page = 1) => apiFetch<Paginated<Project>>(`/projects?page=${page}&per_page=100`),
  // Fetch every page: client-side search also works if the server ignores q.
  all: () => collectPages((page) => projectsApi.list(page)),
  create: (body: ProjectInput) => apiFetch<Project>('/projects', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: ProjectInput) => apiFetch<Project>(`/projects/${id}`, { method: 'PUT', body: JSON.stringify(body) })
};
